var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from "react";
import CustomerService from "../../Customer/services/CustomerService";
import { useCustomer } from "../../App/hooks/useCustomer";
import SupportData from "../../App/components/SupportData";
import "../styles/ChangeEmailData.css";
import Notification from "../../App/components/Notification";
import ModalConfirmEmail from "../components/ModalConfirmEmail";
import ModalConfirmAction from "../components/ModalConfirmAction";
import EmailPreview from "../components/EmailPreview";
import ServerConfigSection from "../components/ServerConfigSection";
import Title from "../../App/components/Title";
import { handleServiceError } from "../../App/components/ErrorHandler";
import EmailServerService from "../Services/EmailServerService";
var EMPTY_SMTP_CONFIG = {
    host: "",
    port: "",
    encryption: "",
    username: "",
    password: "",
    sender_email: "",
};
var REQUIRED_SMTP_FIELDS = ["host", "port", "username", "password", "sender_email"];
function ChangeEmailData() {
    var customer = useCustomer().customer;
    var _a = useState(customer === null || customer === void 0 ? void 0 : customer.support_phone), supportPhone = _a[0], setSupportPhone = _a[1];
    var _b = useState(customer === null || customer === void 0 ? void 0 : customer.support_whatsapp), supportWhatsapp = _b[0], setSupportWhatsapp = _b[1];
    var _c = useState(customer === null || customer === void 0 ? void 0 : customer.support_mail), supportMail = _c[0], setSupportMail = _c[1];
    var _d = useState(customer === null || customer === void 0 ? void 0 : customer.sender_name), senderName = _d[0], setSenderName = _d[1];
    var _e = useState(!!(customer === null || customer === void 0 ? void 0 : customer.support_mail)), emailEnabled = _e[0], setEmailEnabled = _e[1];
    var _f = useState(!!(customer === null || customer === void 0 ? void 0 : customer.support_whatsapp)), whatsappEnabled = _f[0], setWhatsappEnabled = _f[1];
    var _g = useState(!!(customer === null || customer === void 0 ? void 0 : customer.support_phone)), phoneEnabled = _g[0], setPhoneEnabled = _g[1];
    var _h = useState(false), showConfirmEmailModal = _h[0], setShowConfirmEmailModal = _h[1];
    var _j = useState(null), selectedImage = _j[0], setSelectedImage = _j[1];
    var _k = useState(null), selectedService = _k[0], setSelectedService = _k[1];
    var inputRef = useRef(null);
    var _l = useState([]), services = _l[0], setServices = _l[1];
    var _m = useState({}), uploadedImages = _m[0], setUploadedImages = _m[1];
    var _o = useState("celetihub"), serverType = _o[0], setServerType = _o[1];
    var _p = useState(EMPTY_SMTP_CONFIG), smtpConfig = _p[0], setSmtpConfig = _p[1];
    var _q = useState(false), isSavingSmtp = _q[0], setIsSavingSmtp = _q[1];
    var _r = useState(false), hasCustomSmtpConfig = _r[0], setHasCustomSmtpConfig = _r[1];
    var _s = useState(false), isSmtpActive = _s[0], setIsSmtpActive = _s[1];
    var _t = useState(null), pendingServerAction = _t[0], setPendingServerAction = _t[1];
    var _u = useState(false), isSmtpSettingLoaded = _u[0], setIsSmtpSettingLoaded = _u[1];
    useEffect(function () {
        getProductsListWithoutPromotion();
    }, []);
    useEffect(function () {
        EmailServerService.getSmtpSetting()
            .then(function (res) {
            var smtp = res.data.smtp_setting;
            if (smtp) {
                setSmtpConfig(smtp);
                setHasCustomSmtpConfig(true);
                setIsSmtpActive(!!smtp.active);
                setServerType(smtp.active ? "custom" : "celetihub");
            }
        })
            .catch(function () {
            setServerType("celetihub");
        })
            .finally(function () {
            setIsSmtpSettingLoaded(true);
        });
    }, []);
    function getProductsListWithoutPromotion() {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, CustomerService.getProductsWithousPromotion()];
                    case 1:
                        res = _a.sent();
                        setServices(res.data.products);
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleSmtpFieldChange(field, value) {
        setSmtpConfig(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
    }
    function saveAndActivateSmtp() {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsSavingSmtp(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, EmailServerService.saveSmtpSetting(smtpConfig)];
                    case 2:
                        _a.sent();
                        setHasCustomSmtpConfig(true);
                        setIsSmtpActive(true);
                        Notification().Notify.success("Configuração SMTP salva e ativada com sucesso!");
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        handleServiceError(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsSavingSmtp(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function handleSaveSmtp() {
        if (REQUIRED_SMTP_FIELDS.some(function (field) { return !smtpConfig[field]; })) {
            Notification().Notify.failure("Preencha todos os campos obrigatórios do SMTP antes de salvar.");
            return;
        }
        setPendingServerAction("activateSmtp");
    }
    function deactivateCustomSmtp() {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsSavingSmtp(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        if (!hasCustomSmtpConfig) return [3 /*break*/, 3];
                        return [4 /*yield*/, EmailServerService.changeSmtpStatus(false)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        setIsSmtpActive(false);
                        setServerType("celetihub");
                        Notification().Notify.success("Servidor CeletiHub ativado com sucesso!");
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _a.sent();
                        handleServiceError(error_2);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsSavingSmtp(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function handleServerTypeChange(type) {
        if (type === "custom") {
            setServerType("custom");
            return;
        }
        if (serverType !== "custom") {
            setServerType("celetihub");
            return;
        }
        setPendingServerAction("deactivate");
    }
    function handleToggleChannel(channel, enabled) {
        if (channel === "email") {
            setEmailEnabled(enabled);
            if (!enabled)
                setSupportMail("");
        }
        else if (channel === "whatsapp") {
            setWhatsappEnabled(enabled);
            if (!enabled)
                setSupportWhatsapp("");
        }
        else {
            setPhoneEnabled(enabled);
            if (!enabled)
                setSupportPhone("");
        }
    }
    function removeImage() {
        if (!selectedService)
            return;
        setSelectedImage(null);
        setUploadedImages(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[selectedService] = null, _a)));
        });
    }
    useEffect(function () {
        if (!selectedService) {
            setSelectedImage(null);
            return;
        }
        var uploaded = uploadedImages[selectedService];
        setSelectedImage(uploaded !== null && uploaded !== void 0 ? uploaded : null);
    }, [selectedService, uploadedImages]);
    function resizeImageToWidth(file, targetWidth) {
        return new Promise(function (resolve, reject) {
            var objectUrl = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function () {
                var targetHeight = Math.round((img.height / img.width) * targetWidth);
                var canvas = document.createElement("canvas");
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                var ctx = canvas.getContext("2d");
                if (!ctx) {
                    URL.revokeObjectURL(objectUrl);
                    reject(new Error("Não foi possível processar a imagem."));
                    return;
                }
                ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                var outputType = file.type === "image/png" ? "image/png" : "image/jpeg";
                canvas.toBlob(function (blob) {
                    URL.revokeObjectURL(objectUrl);
                    if (!blob) {
                        reject(new Error("Não foi possível processar a imagem."));
                        return;
                    }
                    resolve(new File([blob], file.name, { type: outputType, lastModified: Date.now() }));
                }, outputType, 0.92);
            };
            img.onerror = function () {
                URL.revokeObjectURL(objectUrl);
                reject(new Error("Não foi possível carregar a imagem selecionada."));
            };
            img.src = objectUrl;
        });
    }
    function uploadImage(e) {
        return __awaiter(this, void 0, void 0, function () {
            var file, targetWidth, maxSize, resizedFile_1, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(e.target.files && e.target.files.length > 0)) return [3 /*break*/, 5];
                        file = e.target.files[0];
                        targetWidth = 650;
                        maxSize = 5 * 1024 * 1024;
                        if (file.size > maxSize) {
                            Notification().Notify.failure("O arquivo selecionado excede o tamanho máximo de 5MB.");
                            setSelectedImage(null);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, resizeImageToWidth(file, targetWidth)];
                    case 2:
                        resizedFile_1 = _a.sent();
                        setSelectedImage(resizedFile_1);
                        setUploadedImages(function (prevImages) {
                            var _a;
                            return (__assign(__assign({}, prevImages), (_a = {}, _a[selectedService] = resizedFile_1, _a)));
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        Notification().Notify.failure((error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || "Erro ao processar a imagem selecionada.");
                        setSelectedImage(null);
                        return [3 /*break*/, 5];
                    case 4:
                        e.target.value = "";
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    var handleDivClick = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    function handleInputChangeEmailData(event, type) {
        var value = event.target.value;
        switch (type) {
            case "supportMail":
                setSupportMail(value);
                break;
            case "supportWhatsapp":
                setSupportWhatsapp(value);
                break;
            case "supportPhone":
                setSupportPhone(value);
                break;
            case "senderName":
                setSenderName(value);
                break;
            default:
                break;
        }
    }
    function handleServiceChange(event) {
        var newServiceId = Number(event.target.value);
        setSelectedService(newServiceId);
        setSelectedImage(null);
    }
    function handleSubmit(testEmail) {
        var formData = buildContactFormData();
        formData.append("test_email", testEmail);
        formData.append("service_id", selectedService ? selectedService.toString() : "");
        if (selectedImage) {
            if (!selectedService) {
                Notification().Notify.failure("Por favor, selecione um serviço antes de continuar.");
                return;
            }
            formData.append("image", selectedImage);
        }
        Notification().Loading.dots("Carregando...");
        CustomerService.sendTestCustomerEmailPicture(formData)
            .then(function () {
            Notification().Loading.remove();
            setShowConfirmEmailModal(false);
            Notification().Report.success("Email enviado com sucesso", "Para usar a versão enviada para o destinatário, clique abaixo em salvar.", "Ok", { plainText: true });
        })
            .catch(function (error) {
            var _a, _b;
            Notification().Loading.remove();
            Notification().Notify.failure(((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || "Erro ao tentar enviar o e-mail de teste!");
        });
    }
    function buildContactFormData() {
        var _a, _b, _c, _d;
        var formData = new FormData();
        formData.append("support_mail", emailEnabled ? (_a = supportMail !== null && supportMail !== void 0 ? supportMail : customer.support_mail) !== null && _a !== void 0 ? _a : "" : "");
        formData.append("support_whatsapp", whatsappEnabled ? (_b = supportWhatsapp !== null && supportWhatsapp !== void 0 ? supportWhatsapp : customer.support_whatsapp) !== null && _b !== void 0 ? _b : "" : "");
        formData.append("support_phone", phoneEnabled ? (_c = supportPhone !== null && supportPhone !== void 0 ? supportPhone : customer.support_phone) !== null && _c !== void 0 ? _c : "" : "");
        formData.append("sender_name", (_d = senderName !== null && senderName !== void 0 ? senderName : customer.sender_name) !== null && _d !== void 0 ? _d : "");
        return formData;
    }
    function saveContactInfo() {
        return __awaiter(this, void 0, void 0, function () {
            var formData, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = buildContactFormData();
                        formData.append("action", "contact");
                        Notification().Loading.dots("Carregando...");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, CustomerService.updateCustomerEmailPicture(formData)];
                    case 2:
                        _a.sent();
                        Notification().Loading.remove();
                        Notification().Notify.success("Informações atualizadas com sucesso!");
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        Notification().Loading.remove();
                        handleServiceError(error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function saveDesign() {
        return __awaiter(this, void 0, void 0, function () {
            var formData, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedService) {
                            Notification().Notify.failure("Por favor, selecione um serviço antes de continuar.");
                            return [2 /*return*/];
                        }
                        formData = new FormData();
                        formData.append("action", "design");
                        if (selectedImage) {
                            formData.append("image", selectedImage);
                        }
                        formData.append("service_id", selectedService.toString());
                        Notification().Loading.dots("Carregando...");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, CustomerService.updateCustomerEmailPicture(formData)];
                    case 2:
                        _a.sent();
                        Notification().Loading.remove();
                        Notification().Notify.success("Design atualizado com sucesso!");
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        Notification().Loading.remove();
                        handleServiceError(error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        setSupportMail(customer === null || customer === void 0 ? void 0 : customer.support_mail);
        setSupportWhatsapp(customer === null || customer === void 0 ? void 0 : customer.support_whatsapp);
        setSupportPhone(customer === null || customer === void 0 ? void 0 : customer.support_phone);
        setSenderName(customer === null || customer === void 0 ? void 0 : customer.sender_name);
        setEmailEnabled((customer === null || customer === void 0 ? void 0 : customer.email_enabled) === true ? true : !!(customer === null || customer === void 0 ? void 0 : customer.support_mail));
        setWhatsappEnabled((customer === null || customer === void 0 ? void 0 : customer.whatsapp_enabled) === true ? true : !!(customer === null || customer === void 0 ? void 0 : customer.support_whatsapp));
        setPhoneEnabled((customer === null || customer === void 0 ? void 0 : customer.phone_enabled) === true ? true : !!(customer === null || customer === void 0 ? void 0 : customer.support_phone));
    }, [customer]);
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsxs("div", __assign({ className: "change-email-data-page" }, { children: [_jsx(Title, { text: "E-mail de ativa\u00E7\u00E3o", hr: false }), isSmtpSettingLoaded && (_jsx(ServerConfigSection, { serverType: serverType, onServerTypeChange: handleServerTypeChange, smtpConfig: smtpConfig, onSmtpFieldChange: handleSmtpFieldChange, onSaveSmtp: handleSaveSmtp, isSavingSmtp: isSavingSmtp, isSmtpActive: isSmtpActive, hasSmtpConfig: hasCustomSmtpConfig })), _jsxs("div", __assign({ className: "container-change-email-data", id: "preview-email-desk" }, { children: [_jsxs("div", __assign({ className: "container-upload-image" }, { children: [_jsx("h2", { children: "Informa\u00E7\u00F5es de contato de suporte:" }), _jsx(SupportData, { customer: customer, handleInputChangeEmailData: handleInputChangeEmailData, supportMail: supportMail, supportWhatsapp: supportWhatsapp, supportPhone: supportPhone, emailEnabled: emailEnabled, whatsappEnabled: whatsappEnabled, phoneEnabled: phoneEnabled, onToggleChannel: handleToggleChannel }), _jsxs("div", __assign({ className: "container-support-data-input sender-name-desktop-only" }, { children: [_jsx("label", __assign({ htmlFor: "sender_name" }, { children: "Nome do remetente do email:" })), _jsx("input", { type: "text", id: "sender_name", className: "support-data-input", value: senderName !== null && senderName !== void 0 ? senderName : "", onChange: function (e) { return handleInputChangeEmailData(e, "senderName"); }, placeholder: "Insira o nome do seu provedor..." })] })), _jsxs("div", __assign({ className: "container-support-data-input sender-name-mobile-only" }, { children: [_jsx("label", __assign({ htmlFor: "sender_name_mobile" }, { children: "*T\u00EDtulo do email:" })), _jsx("input", { type: "text", id: "sender_name_mobile", className: "support-data-input", value: senderName !== null && senderName !== void 0 ? senderName : "", onChange: function (e) { return handleInputChangeEmailData(e, "senderName"); }, placeholder: "Insira o nome do Provedor ou um titulo...", required: true })] })), _jsxs("div", __assign({ className: "container-action-buttons-change-email-data" }, { children: [_jsx("button", __assign({ type: "button", className: "submit-test-button", onClick: function () {
                                                    if (selectedService === null) {
                                                        Notification().Notify.failure("Por favor, selecione um serviço antes de continuar.");
                                                    }
                                                    else {
                                                        setShowConfirmEmailModal(true);
                                                    }
                                                } }, { children: "Enviar teste" })), _jsx("div", __assign({ className: "container-action-buttons-mobile" }, { children: _jsx("button", __assign({ type: "button", className: "save-button", onClick: saveContactInfo }, { children: "Salvar Informa\u00E7\u00F5es" })) }))] })), _jsx("hr", { className: "change-email-data-divider" }), _jsx("h2", { children: "Design:" }), _jsxs("select", __assign({ className: "select-change-email-data", onChange: handleServiceChange, defaultValue: 0 }, { children: [_jsx("option", __assign({ value: 0, disabled: true, hidden: true }, { children: "Selecione um servi\u00E7o" })), services.length > 0 ? (services.map(function (service) { return (_jsx("option", __assign({ value: service.id }, { children: service.name }), service.id)); })) : (_jsx("option", __assign({ disabled: true }, { children: "Nenhum servi\u00E7o cadastrado." })))] })), _jsxs("button", __assign({ type: "button", className: "box-upload-email-data", onClick: handleDivClick }, { children: [_jsx("input", { type: "file", accept: "image/*", ref: inputRef, onChange: uploadImage, style: { display: "none" } }), _jsx("span", __assign({ className: "material-symbols-outlined icon-upload-change-email-data" }, { children: "upload_file" })), _jsx("p", { children: "Enviar arquivo" }), _jsx("span", { children: "PNG ou JPG (redimensionada automaticamente para 650px / max. 5MB)" })] })), _jsxs("div", __assign({ className: "container-action-buttons-change-email-data" }, { children: [_jsx("button", __assign({ type: "button", className: "remove-image-button", onClick: removeImage, disabled: !selectedImage }, { children: "Remover imagem" })), _jsx("div", __assign({ className: "container-action-buttons-mobile" }, { children: _jsx("button", __assign({ type: "button", className: "save-button", onClick: saveDesign }, { children: "Salvar Design" })) }))] }))] })), _jsx(EmailPreview, { getProductsListWithoutPromotion: getProductsListWithoutPromotion, selectedImage: null, uploadedImages: uploadedImages, services: services, selectedService: selectedService, supportMail: supportMail, supportWhatsapp: supportWhatsapp, supportPhone: supportPhone, customer: customer })] }))] })), showConfirmEmailModal && (_jsx(ModalConfirmEmail, { show: showConfirmEmailModal, onConfirm: handleSubmit, closeModal: function () { return setShowConfirmEmailModal(false); } })), pendingServerAction === "deactivate" && (_jsx(ModalConfirmAction, { show: true, title: "Tem certeza que quer mudar suas configura\u00E7\u00F5es de envio de email?", message: "Ao clicar em confirmar, voc\u00EA vai alterar a origem de envio dos seus emails de ativa\u00E7\u00E3o. Deseja prosseguir?", onConfirm: function () {
                    setPendingServerAction(null);
                    deactivateCustomSmtp();
                }, closeModal: function () { return setPendingServerAction(null); } })), pendingServerAction === "activateSmtp" && (_jsx(ModalConfirmAction, { show: true, title: "Tem certeza que quer mudar suas configura\u00E7\u00F5es de envio de email?", message: "Ao clicar em confirmar, essa configura\u00E7\u00E3o de servidor pr\u00F3prio ser\u00E1 salva e passar\u00E1 a ser usada para o envio dos emails de ativa\u00E7\u00E3o.", confirmText: "Salvar e ativar", onConfirm: function () {
                    setPendingServerAction(null);
                    saveAndActivateSmtp();
                }, closeModal: function () { return setPendingServerAction(null); } }))] })));
}
export default ChangeEmailData;
